import { EMAIL_METADATA, FILES } from 'conversations-message-history/common-message-format/constants/attachmentTypes';
export const getDraftAttachmentTypename = type => {
  switch (type) {
    case FILES:
      return 'com.hubspot.cv.pubsub.core.message.common.Files';
    case EMAIL_METADATA:
      return 'com.hubspot.cv.pubsub.core.message.common.EmailMetadata';
    default:
      return type;
  }
};